import React, { useEffect, useMemo, useState } from "react";
import { ColorAddedPlayer, IPlayerComparisonData } from "../../types/IPlayerComparison";
// import { ScattrPlot } from "./ScattrPlot";
// import { IPlotFilter, PlotPlayerSiderbarList } from "./ScattrPlotUtils";
import { useLoading } from "../../contexts/LoadingContext";
import { useAuth } from "../../contexts/AuthContext";
import { useNotification } from "../../contexts/NotificationContext";
import CloseIcon from "@mui/icons-material/Close";
// import { addUpdateSortListData } from "./addOrUpdateSortList";
import Collpase from "../../assets/icons/Collapse.png";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../ui/SecondaryButton";
import LabelText from "../../ui/LabelText";
import Switch from "../../ui/CustomSwitch";
import RemoveIcon from "../../assets/icons/remove.png";
import { useNewPlayerShortlistContext } from "../../contexts/NewPlayerShortlistContext";
import { IPlayerCardDetail } from "../../types/IPlayerCardDetail";
import { fetchPlayerCardData } from "../../pages/Chemistry/Utils";
import { ColorAddedClub, IClubComparisonData } from "../../types/ClubComparison";
import { generateRandomUniqueColors, IClubFilter, PlotClubSiderbarList } from "./ClubPlotUtils";
import { addUpdateClubSortListData } from "./addOrUpdateClubSortlist";
import { ClubPlot } from "./ClubPlot";

interface PlotComparisonProps {
  clubComparisonData: IClubComparisonData[];
  clubPlotFilters: IClubFilter;
  isFormSortList: boolean;
  acrossSortDirection: "inc" | "dec";
  upSortDirection: "desc" | "asc";
}

export const ClubPlotComparison: React.FC<PlotComparisonProps> = ({
  clubComparisonData,
  clubPlotFilters,
  isFormSortList,
  acrossSortDirection,
  upSortDirection,
}) => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const { showNotification, hideNotification, displayNotification, setDisplayNotification, notificationContent, setNotificationContent } = useNotification();
  const clubComparisonTableData = useMemo(
    () =>
      clubComparisonData?.map((club) => ({
        ...club,
        finishingShots: club?.teamFinalThird.finishingShots,
        finishingAerial:club?.teamFinalThird?.finishingAerial,
        attackPositioning:club?.teamFinalThird?.attackPositioning,
        creativity:club?.teamBuildUpPlay?.creativity,
        passingAccuracy:club?.teamBuildUpPlay?.passingAccuracy,
        dribbling:club?.teamBuildUpPlay?.dribbling,
        crossing:club?.teamBuildUpPlay?.crossing,
        tackling:club?.teamDefence?.tackling,
        defensiveHeaders:club?.teamDefence?.defensiveHeaders,
        aggression:club?.teamDefence?.aggression,
        ppg:club?.archetypes?.ppg
      })),
    [clubComparisonData]
  );
  const colorsRange = useMemo(() => generateRandomUniqueColors(clubComparisonTableData?.length), [clubComparisonData]);
  const [hoveredClub, setHoveredClub] = useState<number>(0);
  const { loading, startLoading, stopLoading } = useLoading();
  const [selectedClubs, setSelectedClubs] = useState<number[]>([]);
  const [hiddenClubs, setHiddenClubs] = useState<number[]>([]);
  const [isChunkActive, setIsChunkActive] = useState<boolean>(false);
  const [selectedSimilarClub, setSelectedSimilarClub] = useState<ColorAddedClub | null>(null);
  const [clubCardID, setClubCardID] = useState<number>(0);
  const [colorsAddedClubs, setColorsAddedClubs] = useState(
    clubComparisonTableData?.map((club, i) => ({ ...club, colorCode: colorsRange[i] })) as ColorAddedClub[]
  );
  useEffect(
    () => setColorsAddedClubs(clubComparisonTableData?.map((club, i) => ({ ...club, colorCode: colorsRange[i] })) as ColorAddedClub[]),
    [clubComparisonTableData]
  );
  const filteredClubs = useMemo(
    () => colorsAddedClubs?.filter((club) => !hiddenClubs?.includes(club?.teamId)),
    [hiddenClubs, colorsAddedClubs, clubComparisonTableData]
  );
  const handleHiddenClubs = () => {
    setHiddenClubs((prev) => [...prev, ...selectedClubs]);
    setSelectedClubs([]);
  };
  const handleAllSelected = () => {
    setSelectedClubs(clubComparisonTableData?.map((club) => club?.teamId));
    setHiddenClubs([]);
  };
  const handleRemoveClubs = (clubsToRemove: number[], clubToRemoveFrom: "hidden" | "selected") => {
    addUpdateClubSortListData(
      userData,
      clubsToRemove,
      startLoading,
      stopLoading,
      setDisplayNotification,
      setNotificationContent,
      true,
      navigate
    );
    if (clubToRemoveFrom === "hidden") {
      setHiddenClubs([]);
    }
    if (clubToRemoveFrom === "selected") {
      setSelectedClubs([]);
    }
    setColorsAddedClubs((prevData) => prevData.filter((club) => !clubsToRemove.includes(club?.teamId)));
  };
  const handleRemoveSingleClub = (clubToRemove: number) => {
    addUpdateClubSortListData(userData, [clubToRemove], startLoading, stopLoading, setDisplayNotification, setNotificationContent, true);
    if (hiddenClubs?.includes(clubToRemove)) {
      setHiddenClubs((prev) => prev.filter((club) => club !== clubToRemove));
    }
    if (selectedClubs?.includes(clubToRemove)) {
      setSelectedClubs((prev) => prev.filter((club) => club !== clubToRemove));
    }
    setColorsAddedClubs((prevData) => prevData.filter((club) => club?.teamId !== clubToRemove));
  };

  return (
    <div className="plot-comparison-container">
      <PlotClubSiderbarList
        isNickName={false}
        isChunkActive={isChunkActive}
        setHiddenClubs={setHiddenClubs}
        hiddenClubs={hiddenClubs}
        selectedSimilarClub={selectedSimilarClub}
        setSelectedClubs={setSelectedClubs}
        selectedClubs={selectedClubs}
        colorsAddedClubs={colorsAddedClubs}
        hoveredClub={hoveredClub}
        setHoveredClub={setHoveredClub}
        clubCardId={clubCardID}
        setClubCardId={setClubCardID}
      />
      <div className="scattr-plot-container">
        <ClubPlot
          setSelectedClubs={setSelectedClubs}
          upSortDirection={upSortDirection}
          acrossSortDirection={acrossSortDirection}
          selectedClubs={selectedClubs}
          clubPlotFilters={clubPlotFilters}
          colorsAddedClubs={clubComparisonTableData}
          filteredClubs={filteredClubs}
          hoveredClub={hoveredClub}
          setHoveredClub={setHoveredClub}
          setClubCardID={setClubCardID}
          clubCardID={clubCardID}
        />
      </div>
      <div className="plot-comparison-toolbar">
        <div>
          <button className="display-none"></button>
          {selectedClubs?.length !== clubComparisonData?.length && <button onClick={() => handleAllSelected()}>Select all</button>}
          {selectedClubs?.length > 0 && <button onClick={() => setSelectedClubs([])}>Deselect all</button>}
          {hiddenClubs?.length > 0 && (
            <button className={`chunk-icon ${isChunkActive && "chunk-active-icon"}`} onClick={() => setIsChunkActive(!isChunkActive)}>
              <img src={Collpase} alt="" />
            </button>
          )}
          {hiddenClubs?.length > 0 && isFormSortList && (
            <button onClick={() => handleRemoveClubs(hiddenClubs, "hidden")} className="remove-hidden-players-button">
              <img src={RemoveIcon} height={24} width={24} />
              Remove hidden players
            </button>
          )}
        </div>
        {selectedClubs?.length > 0 && (
          <div>
            <p>SELECTION OPTIONS:</p>
            <button onClick={() => handleHiddenClubs()}>Hide selected</button>
            {selectedClubs?.length !== clubComparisonData?.length && (
              <button
                onClick={() =>
                  setHiddenClubs(clubComparisonData?.filter((club) => !selectedClubs?.includes(club?.teamId))?.map((club) => club?.teamId))
                }
              >
                Hide not selected
              </button>
            )}
            {!isFormSortList && (
              <button
                onClick={() => {
                  //   setNewlyAddedPlayerCount((prev) => prev + selectedPlayers?.length);
                  addUpdateClubSortListData(
                    userData,
                    selectedClubs,
                    startLoading,
                    stopLoading,
                    setDisplayNotification,
                    setNotificationContent,
                    false,
                    navigate
                  );
                }}
              >
                Add to shortlist
              </button>
            )}
            {isFormSortList && (
              <button onClick={() => handleRemoveClubs(selectedClubs, "selected")} className="remove-hidden-players-button">
                Remove from shortlist
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
